export class LocalStorageUtil  {
    private readonly storageName = "healioLocalStorage";
    private dataStore = "";

    constructor(dataStore: string) {
        if (!this.isLocalStorageAvailable()) {
            return;
        }
        this.dataStore = dataStore;
      }

    private isLocalStorageAvailable() : boolean{
        if (window === undefined || typeof(window.localStorage) !== 'object') {
            return false;
        }
        var test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch(e) {
            return false;
        }
    }

    // I think we might want to call this on logout... maybe?
    public clearLocalStorage() : boolean {
        const localStorageKeys = Object.keys(window.localStorage)
        for (let index = 0; index < localStorageKeys.length; ++index) {
            var storageKey = localStorageKeys[index];
            if (storageKey.startsWith(this.storageName)){
                localStorage.removeItem(storageKey);
            }
          }

        return true;
    }

    public deleteItem(dataStore: string, keyarray: string[]):
    // JUSTIFICATION : ANYthing can be in datastore. Might be a bit tedious
    // to create type specific local storage functions
    // tslint:disable-next-line: no-any
    boolean {
        let key = keyarray.join("|").toLowerCase();
        if(!this.isLocalStorageAvailable()) {
            return false;
        }
        key = `${this.storageName}/${this.dataStore}/${key}`
        localStorage.removeItem(key);
        return true;
    }
    // JUSTIFICATION : ANYthing can be stored. Might be a bit tedious
    // to create type specific local storage functions
    // tslint:disable-next-line: no-any
    public insertItem(dataStore: string, keyarray: string[], value: any):
    boolean {
        let key = keyarray.join("|").toLowerCase();
        key = `${this.storageName}/${this.dataStore}/${key}`
        if(!this.isLocalStorageAvailable()) {

            return false;
        }
        localStorage.setItem(key,JSON.stringify(value));
        return true;
    }

    public getItem(dataStore: string, keyarray: string[]):
    // JUSTIFICATION : ANYthing can be in datastore. Might be a bit tedious
    // to create type specific local storage functions
    // tslint:disable-next-line: no-any
    any | null {
        let key = keyarray.join("|").toLowerCase();
        key = `${this.storageName}/${this.dataStore}/${key}`
        if(!this.isLocalStorageAvailable()) {

            return null;
        }
        let retrievedItem = localStorage.getItem(key);

        return retrievedItem ? JSON.parse(retrievedItem) : null;
    }

    public getItemSimple(key: string):
    any | null {
        if(!this.isLocalStorageAvailable())
        {
            return null;
        }
        return localStorage.getItem(key);
    }

};
